import { apiFetch } from './apiClient';

export type IncludedApp = {
  schemaVersion: 1;
  id: string;
  name: string;
  description: string;
  version: string;
  launchPath: string;
  configurationPath?: string;
  iconPath?: string;
  audience: 'all-users' | 'admins';
};

export async function listIncludedApps(): Promise<IncludedApp[]> {
  const response = await apiFetch('/api/included-apps');
  if (!response.ok) throw new Error('Included applications could not be loaded. Please try again.');
  return response.json() as Promise<IncludedApp[]>;
}
